import { useQuery } from "react-query";
import { GetAllScoreCardCounts } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

export const useGetScoreCardCount = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetScoreCardCount",
    GetAllScoreCardCounts,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
